import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../../contexts/AdminContext';
import AdminSidebar from '../../components/Admin/AdminSidebar';
import AdminDashboard from '../../components/Admin/AdminDashboard';
import UserTable from '../../components/Admin/UserTable';
import LogTable from '../../components/Admin/LogTable';
import AdvertisementTable from '../../components/Admin/AdvertisementTable';
import SystemSettingsForm from '../../components/Admin/SystemSettingsForm';
import AdminNotifications from '../../components/Admin/AdminNotifications';
import ContactMessagesTable from '../../components/Admin/ContactMessagesTable';
import ModerationReportsTable from '../../components/Admin/ModerationReportsTable';

const AdminPage = () => {
  const { isAdmin } = useAdmin();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');

  React.useEffect(() => {
    if (!isAdmin) {
      navigate('/notes');
    }
  }, [isAdmin, navigate]);

  if (!isAdmin) {
    return null;
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <AdminDashboard />;
      case 'members':
        return <UserTable />;
      case 'logs':
        return <LogTable />;
      case 'advertisements':
        return <AdvertisementTable />;
      case 'notifications':
        return <AdminNotifications />;
      case 'system':
        return <SystemSettingsForm />;
      case 'contactMessages':
        return <ContactMessagesTable />;
      case 'moderation':
        return <ModerationReportsTable />;
      default:
        return <AdminDashboard />;
    }
  };

  return (
    <div className="flex flex-1 overflow-hidden h-full bg-white dark:bg-[var(--color-bg-base)]">
      <AdminSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="flex-1 overflow-y-auto min-h-0 bg-white dark:bg-[var(--color-bg-base)]">
        <div
          className={`mx-auto w-full p-6 xl:p-8 ${
            activeTab === 'members' || activeTab === 'dashboard' || activeTab === 'moderation'
              ? 'max-w-[1400px]'
              : 'max-w-6xl'
          }`}
        >
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default AdminPage;
